module.exports = __webpack_public_path__ + "static/use-case-3-content-6-5ee0c4dd1d637ea6ec9911c626628e95.png";